<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { incomeExpenseItemService } from "../../../../services/settingservice/incomeexpenseitem.service";

import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Income Expense Item List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      itemTypeData: {},
      data: {},
      fetchingStats: false,
      title: "Income Expense Item List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      incomeExpenseItemService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.data = response;
        });
    },

    

    deleted: function(id) {
      incomeExpenseItemService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-incomeexpense-item-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-incomeexpense-item-add'}" :title="$t('setting.income-expense-item.text')" />
    <List v-if="data" v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('setting.income-expense-item.name')}`,
            `name_en: ${$t('setting.income-expense-item.name-en')}`,
            `type_name: ${$t('setting.income-expense-item.type')}`,
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-incomeexpense-item-edit'}"
          v-bind:filter="{
            search: ['income_expense_items.name', 'income_expense_items.name_en'],
            dropdown: [{
              title: 'setting.income-expense-item.type',
              field: 'income_expense_items.item_type_id',
              data: this.itemTypeData.data,
            }]
          }"
          
    />      
  </Layout>
</template>